import { GenericTable } from "../../../../../../components/GenericTable/GenericTable";
import { ServiceRequestActions } from "../../ServiceRequest/ServiceRequestAction";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { Stack, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import { BiotechOutlined } from "@mui/icons-material";
import { NoDataWarning } from "@/components/common";

export function Solicitations({
  rowData = [],
  resultsData,
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
}: any) {
  // Dados já vêm processados e filtrados do componente Documents
  // Apenas define as colunas da tabela
  const columns = [
    {
      column: "Descrição",
      rowName: "description",
    },
    { column: "Data", rowName: "date" },
    { column: "Categoria", rowName: "category" },
    { column: "Profissional solicitante", rowName: "practitioner" },
  ];

  if (isMobile) {
    return (
      <Stack spacing={2}>
        <>
          {rowData && rowData?.length > 0 ? (
            rowData?.map((row: any) => (
              <DocumentCard
                key={row.id}
                title={row.description || "Solicitação de Exame"}
                date={row.date}
                practitioner={row.practitioner}
                specialty={row.specialty}
                status={{
                  text: row.category,
                  color: "#2196F3",
                  icon: <BiotechOutlined fontSize="small" />,
                }}
                actions={
                  <ServiceRequestActions
                    setRefetch={setRefetch}
                    row={row}
                    handleOpen={handleOpen}
                    setBinaryUrl={setBinaryUrl}
                    cardActions
                  />
                }
              >
                {row.resultUrls && row.resultUrls.length > 0 && (
                  <Typography
                    variant="body2"
                    color="success.main"
                    sx={{ mt: 1 }}
                  >
                    {row.resultUrls.length > 1
                      ? `${row.resultUrls.length} resultados disponíveis`
                      : "Resultado disponível"}
                  </Typography>
                )}
              </DocumentCard>
            ))
          ) : (
            <NoDataWarning />
          )}
        </>
      </Stack>
    );
  }

  return (
    <GenericTable
      tableColumns={columns}
      tableRows={rowData}
      actions={(rowData: any) => (
        <ServiceRequestActions
          setRefetch={setRefetch}
          row={rowData}
          handleOpen={handleOpen}
          setBinaryUrl={setBinaryUrl}
        />
      )}
    />
  );
}
